import { defaultVhcItems } from '../pages/record/vhc/model/utils';
import { useRecordStore } from './record-store';
import { VhcItem } from './types';
import { useVhcStore } from './vhc-store';
import { useMemo } from 'react';

export function useEffectiveItems() {
  const { items } = useRecordStore();
  const { recordModalData } = useVhcStore();
  return useMemo(() => {
    // Если нет айтемов с сервера, возвращаем дефолтные
    // (без повторного добавления isNew, т.к. оно уже есть)
    if (!items || items.length === 0) return [...defaultVhcItems];

    // Собираем все айтемы с сервера
    const result: VhcItem[] = [...items];

    // Добавляем дефолтные айтемы, которых нет на сервере
    defaultVhcItems.forEach((defItem) => {
      const hasServer = items.some((item) => item.type === defItem.type && item.group === defItem.group);
      if (!hasServer) {
        // Добавляем дефолтный айтем без изменений, isNew уже есть
        result.push(defItem);
      }
    });

    // Сортируем по порядку из дефолтных айтемов
    const order = defaultVhcItems.map((i) => `${i.type}_${i.group}`);
    result.sort((a, b) => {
      const aKey = `${a.type}_${a.group}`;
      const bKey = `${b.type}_${b.group}`;
      return order.indexOf(aKey) - order.indexOf(bKey);
    });

    return result;
  }, [items, recordModalData]);
}
